import { IsNotEmpty } from "class-validator";
export class AssetControlRequest {
    @IsNotEmpty()
    assetsActionControlId: number;
    @IsNotEmpty()
    qrCodeType: string;
}